import { Asset } from "assets.gen";
import { getImage } from "./images";
import { GAME_W, GAME_H } from "./data";
import { DRAWING_MODE_DOUBLE } from "./data";
import { random } from "core/math";
import { landscape } from "./terrain";
import { copter } from "./copter";
import { camera } from "./camera";

export const background = {
  _kxs: [] as number[],
  _layers: [] as { src: string; kx: number; ky: number }[],
  _starCanvases: [] as OffscreenCanvas[],
  _initialized: false,

  reset(): void {
    this._layers = [];
    this._kxs = [];
    this._starCanvases = [];

    this._layers.push({ src: Asset.gfx_bg_forest0, kx: 0.1, ky: 0.0 });

    const star1 = this.createStarCanvas(52, 0.3);
    const star2 = this.createStarCanvas(26, 0.6);
    if (star1) {
      this._starCanvases.push(star1);
      this._layers.push({ src: "", kx: 0.2, ky: 0.0 });
    }
    if (star2) {
      this._starCanvases.push(star2);
      this._layers.push({ src: "", kx: 0.4, ky: 0.0 });
    }

    const merged = this.createMergedBackground();
    if (merged) {
      this._starCanvases.push(merged);
      this._layers.push({ src: "", kx: 1.0, ky: 0.0 });
    }

    for (let i = 0; i < this._layers.length; i++) {
      this._kxs.push(this._layers[i].kx);
    }

    this._initialized = true;
  },

  createStarCanvas(numStars: number, alpha: number): OffscreenCanvas | null {
    const canvas = new OffscreenCanvas(GAME_W, GAME_H);
    const sctx = canvas.getContext("2d")!;
    for (let i = 0; i < numStars; i++) {
      const sx = (random() * GAME_W) | 0;
      const sy = (random() * GAME_H) | 0;
      sctx.fillStyle = `rgba(255,255,255,${alpha})`;
      sctx.fillRect(sx, sy, 1, 1);
    }
    return canvas;
  },

  createMergedBackground(): OffscreenCanvas | null {
    const img1 = getImage(Asset.gfx_bg_forest1);
    const img2 = getImage(Asset.gfx_bg_forest2);
    if (!img1 || !img2) return null;

    const canvas = new OffscreenCanvas(img1.width, img1.height * 2);
    const mctx = canvas.getContext("2d")!;

    if (landscape._mode === DRAWING_MODE_DOUBLE) {
      mctx.drawImage(img2, 0, 0);
    }
    mctx.drawImage(img1, 0, img2.height);
    return canvas;
  },

  update(): void {},

  render(ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D): void {
    if (!this._initialized) return;

    ctx.fillStyle = "#1a1a2e";
    ctx.fillRect(0, 0, GAME_W, GAME_H);

    let starIdx = 0;
    for (let i = 0; i < this._layers.length; i++) {
      const layer = this._layers[i];
      const shift = -(camera.x * this._kxs[i]);

      if (layer.src) {
        const img = getImage(layer.src);
        if (img) {
          const pattern = ctx.createPattern(img, "repeat");
          if (pattern) {
            ctx.save();
            const offsetY = layer.ky
              ? ((((copter.y - GAME_H * 0.5) * layer.ky) % img.height) + img.height) % img.height
              : 0;
            const offsetX = ((shift % img.width) + img.width) % img.width;
            ctx.translate(offsetX, offsetY);
            ctx.fillStyle = pattern;
            ctx.fillRect(-img.width, -img.height, GAME_W + img.width, GAME_H + img.height);
            ctx.restore();
          }
        }
      } else if (starIdx < this._starCanvases.length) {
        const starCanvas = this._starCanvases[starIdx];
        starIdx++;
        if (starCanvas) {
          const cw = starCanvas.width;
          const sx = ((shift % cw) + cw) % cw;
          ctx.drawImage(starCanvas, sx, 0);
          if (sx > 0) {
            ctx.drawImage(starCanvas, sx - cw, 0);
          }
        }
      }
    }
  },
};
